import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy loading de componentes de autenticación - usando named exports correctamente
const LoginForm = lazy(() => import('@feature/auth').then(m => ({ default: m.LoginForm })));
const Callback = lazy(() => import('@feature/auth').then(m => ({ default: m.Callback })));

import { ROUTES } from '@shared/constants/routes.constants';

/**
 * Rutas públicas (sin autenticación)
 */
export const publicRoutes: RouteObject[] = [
  {
    path: ROUTES.PUBLIC.LOGIN,
    element: <LoginForm />,
  },
  {
    path: ROUTES.PUBLIC.CALLBACK,
    element: <Callback />,
  },
];
